<template>
  <div class="main-container scrollbar-y">
    <div class="page-header">
      <div class="page-title">联盟管理</div>
    </div>
    <div class="page-body">
      <el-form class="ezz-list-search" size="mini" :inline="true">
        <el-form-item label="分类">
          <el-select v-model="query.category_id" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in categoryList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联盟名称">
          <el-input size="mini" placeholder="联盟名称" v-model="query.title" style="width: 130px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="注册日期">
          <el-date-picker type="daterange" size="mini" v-model="dateRange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 240px;"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="success" plain icon="el-icon-search" @click="handlerSearch">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="dataList" size="mini" border header-row-class-name="datalist-header" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column type="expand">
          <template v-slot:default="scope">
            <el-form label-width="140px" style="background-color: #efefef;">
              <el-row :gutter="20">
                <el-col :span="20">
                  <el-row :gutter="20" style="padding-top: 15px;">
                    <el-col :span="6">
                      <el-form-item  label="联盟名称：">{{scope.row.title}}</el-form-item>
                      <el-form-item  label="创建人：">{{scope.row.user_name}}</el-form-item>
                      <el-form-item  label="联系人： ">{{scope.row.linkman}}</el-form-item>
                      <el-form-item  label="公司地址：">{{scope.row.address}}</el-form-item>
                      <el-form-item   label="创建时间：">{{scope.row.create_time}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item  label="所属分类：">{{scope.row.category_name}}</el-form-item>
                      <el-form-item  label="运营商：">{{scope.row.Operator}}</el-form-item>
                      <el-form-item  label="邮箱：">{{scope.row.email}}</el-form-item>
                      <el-form-item  label="联系电话：">{{scope.row.phone}}</el-form-item>
                      <el-form-item  label="所属地区：">{{scope.row.province + ' ' + scope.row.city + ' ' + scope.row.district}}</el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item  label="开放程度：">{{scope.row.opening_level === "0" ? "开放" : scope.row.opening_level === "1" ? "半开放" : "不开放"}}</el-form-item>
                      <el-form-item  label="盟友公开：">{{ scope.row.open_user === "0" ? "公开" : "不公开"}}</el-form-item>
                      <el-form-item  label="是否推荐：">{{ scope.row.iscommended === "0" ? "不推荐" : "推荐"}}</el-form-item>
                      <el-form-item  label="是否接收平台数据：">{{scope.row.get_data_from_platform === "0" ? "不接受" : "接收"}}</el-form-item>
                      <el-form-item  label="排序：">{{scope.row.sort}}</el-form-item>
                    </el-col>
                  </el-row>
                  <el-divider style="background-color: #efefef">联盟介绍</el-divider>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <div class="txtC" v-html="scope.row.intro"></div>
                    </el-col>
                  </el-row>
                  <el-divider style="background-color: #efefef;">运营商介绍</el-divider>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <div class="txtC" v-html="scope.row.operator_intro"></div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="4">
                  <div class="form-attaches-container">
                    <div class="form-attaches-title">联盟Logo</div>
                    <div class="avatar-uploader"><img v-if="scope.row.logo" :src="scope.row.logo" class="avatar"></div>
                    <div class="form-attaches-title" style="margin-top: 20px;">联盟图片</div>
                    <div class="avatar-uploader"><img v-if="scope.row.images" :src="scope.row.images" class="avatar"></div>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="唯一标识 id" width="140" align="center"></el-table-column>
        <el-table-column prop="title" label="联盟名称" width="250" align="center"></el-table-column>
        <el-table-column prop="create_time" label="发布时间" align="center"></el-table-column>
        <el-table-column prop="category_name" label="所属分类" align="center"></el-table-column>
        <el-table-column prop="user_name" label="发布者" align="center"></el-table-column>
        <el-table-column prop="operator" label="运营商" width="250" align="center"></el-table-column>
        <el-table-column prop="status" label="审核状态" width="120" align="center">
          <template v-slot:default="scope">
            <el-select v-if="scope.row.editstatus" v-model="scope.row.status" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in statusArr" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select>
            <div v-else>
              <span v-if="scope.row.status === '1'" style="color:#32CD32;">通过</span>
              <span v-else-if="scope.row.status === '0'" style="color:#CD853F;">未审核</span>
              <span v-else-if="scope.row.status === '2'" style="color:#DC143C;">未通过</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template v-slot:default="scope">
            <el-button :type="scope.row.editstatus?'success':'primary'" size="mini" :icon="scope.row.editstatus?'el-icon-finished':'el-icon-s-check'" circle @click="scope.row.editstatus?handlerSave(scope.row):isEditedable(scope.row)"></el-button>
            <el-button type="warning" size="mini" icon="el-icon-view" circle @click="showCards(scope.row)"></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handlerDel(scope.row, scope.$index)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px;" @size-change="handlerSizeChange" @current-change="handlerCurrentChange" :current-page="query.pn" :page-sizes="[15, 30, 50, 100]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
    </div>
    <cards ref="cards" :parent="this" />
  </div>
</template>

<script>
import apis from './module.apis.js'
import cards from './GetMembers.vue'
export default {
  name: 'AccountList',
  data: () => {
    return {
      operate_id: JSON.parse(sessionStorage.getItem('admin')).id,
      categoryList: [],
      query: {
        category_id: '',
        title: '',
        endDate: '',
        pageSize: 15,
        pn: 1
      },
      dataList: [],
      lastRow: { editstatus: false },

      statusArr: [
        { key: '1', label: '通过' },
        { key: '2', label: '未通过' },
        { key: '0', label: '未审核' }
      ],
      // 日期范围
      dateRange: [],
      dataList: [],
      pageCount: 0,
      totalCount: 0
    }
  },

  mounted: function () {
    this.loadData()
  },
  components: {
    cards
  },
  methods: {
    showCards: function (row) {
      this.$refs.cards.open(row)
    },

    // 加载数据
    loadData: function () {
      const _this = this
      if (_this.dateRange && _this.dateRange.length > 0) {
        _this.query.startDate = _this.dateRange[0]
        _this.query.endDate = _this.dateRange[1]
      } else {
        _this.query.startDate = ''
        _this.query.endDate = ''
      }
      _this.post(apis.GetList, _this.query, function (res) {
        const _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.$router.replace({
            path: '/'
          })
        } else {
          console.log('dataList', _json.dataList)
          _this.categoryList = _json.categoryList
          _this.dataList = _json.dataList
          _this.currentRow = _this.dataList[0]
          _this.totalCount = _json.totalCount
          _this.query.pn = _json.pn
        }
      })
    },

    rowClick: function (row) {
      this.currentRow = row
      console.log(row.logo)
    },

    GetNowDateTime: function () {
      var data = new Date()
      var month = data.getMonth() < 10 ? '0' + (data.getMonth() + 1) : data.getMonth() + 1
      var date = data.getDate() < 10 ? '0' + data.getDate() : data.getDate()
      var hour = data.getHours < 10 ? '0' + data.getHours() : data.getHours()
      var minute = data.getMinutes < 10 ? '0' + data.getMinutes : data.getMinutes()
      var second = data.getSeconds < 10 ? '0' + data.getSeconds : data.getSeconds()
      var value = data.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
      return value
    },

    save: function (model) {
      this.currentRow = model
      if (model.id === '系统自动生成') {
        model.creater_id = this.operate_id
        model.create_time = this.GetNowDateTime()
        this.handlerSave(model)
      } else {
        model.update_id = this.operate_id
        model.updater_time = this.GetNowDateTime()
        this.handlerSave(model)
      }
    },

    delete: function (model) {
      model.deleter_id = this.operate_id
      model.delete_time = this.GetNowDateTime()
      this.handlerSave(model)
    },

    isEditedable: function (row) {
      this.$set(row, 'editstatus', true)
    },

    // 保存
    handlerSave: function (model) {
      const _this = this

      _this.post(apis.Save, model, function (res) {
        const _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '操作成功',
            type: 'success'
          })
          _this.loadData()
          _this.lastRow.editstatus = false
        } else {
          _this.$message.error(_json.msg)
        }
      })
    },

    handlerDel: function (_row, _index) {
      const _this = this
      _this
        .$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          if (_row.id === '系统自动生成') {
            _this.$delete(_this.dataList, _index)
            _this.lastRow.editstatus = false
          } else _this.delete(_row)
        })
    },

    handlerAddBean: function () {
      const bean = JSON.parse(JSON.stringify(this.emptyBean))
      bean.editstatus = true
      bean.id = '系统自动生成'
      bean.create_time = '系统自动生成'
      this.dataList.push(bean)
      this.lastRow = bean
    },

    handlerSearch: function () {
      this.loadData()
    },
    handlerSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadData()
    },
    handlerCurrentChange: function (pageIndex) {
      this.query.pn = pageIndex
      this.loadData()
    }
  }
}
</script>